const passwordAlphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
const hexAlphabet = '0123456789abcdef';

/** Create a cryptographically secure, visually unambiguous password. */
export function createPassword(size = 16): string {
    return createSecureString(size, passwordAlphabet);
}

/** Create a cryptographically secure lowercase hexadecimal string. */
export function createHexString(size = 32): string {
    return createSecureString(size, hexAlphabet);
}

function createSecureString(size: number, alphabet: string): string {
    if (!Number.isInteger(size) || size < 0)
        throw new Error('Secure string size must be a non-negative integer.');
    const secureCrypto = globalThis.crypto;
    if (!secureCrypto?.getRandomValues)
        throw new Error('Secure random generation requires crypto.getRandomValues.');

    const limit = 0x1_0000_0000 - (0x1_0000_0000 % alphabet.length);
    let result = '';
    while (result.length < size) {
        const values = new Uint32Array(Math.min(size - result.length, 256));
        secureCrypto.getRandomValues(values);
        for (const value of values) {
            if (value >= limit) continue;
            result += alphabet[value % alphabet.length];
        }
    }
    return result;
}
